import { Preguntas as c } from "../EditPanel/Preguntas";
import { conLanding } from "../Models/Landing";

export default class Preguntas extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}